
jQuery( function( $ ) {
    const mobileQuery = window.matchMedia( '(max-width: 640px)' );
    const iconLists = document.querySelectorAll( '.icons-descriptions__list' );
    let slicked = false;
    const options = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        centerMode: true,
        centerPadding: '10%'
    };

    mobileQuery.addEventListener( 'change', setIconsState );
    setIconsState();

    function setIconsState() {
        if ( mobileQuery.matches && !slicked ) {
            iconLists.forEach( list => $( list ).slick( options ) );
            slicked = true;
        } else if ( !mobileQuery.matches && slicked ) {
            iconLists.forEach( list => $( list ).slick( 'unslick' ) );
            slicked = false;
        }
    }

} );